import InputMask from 'react-input-mask'

const MaskedInput = (props) => {
    return (
        <div className="form-row" style={props.containerStyle}>
            <label
                style={props.labelStyle}
                htmlFor={props.htmlFor}
                className="form-label">
                {props.label}
            </label>
            <InputMask
                type={props.type}
                id={props.id}
                name={props.name}
                mask={props.mask}
                placeholder={props.placeholder}
                onChange={props.onChange}
                value={props.value}
                required={props.required}
                className="form-input"
                style={props.inputStyle}
            />
        </div>
    )
}
export default MaskedInput
